import tns from '../procedures_tn';

function importAll(r) {
    let images = {}

    r.keys().forEach((item, index) => {
        let name = item.replace('./', '');
        name = name.substr(0, name.indexOf("."));

        let pos1 = name.indexOf("_");
        let pos2 = name.indexOf("_", pos1 + 1);
        const id = name.substr(pos1 + 1, pos2 - pos1 - 1);
        const type = name.substr(pos2 + 1);
        name = name.substr(0, name.indexOf("_"));
        if (!images[name]) images[name] = {};
        if (!images[name][`_${id}`]) images[name][`_${id}`] = {};
        if (type === "before") {
            images[name][`_${id}`] = {
                ...images[name][`_${id}`], before: r(item)
            }
        }
        else {
            images[name][`_${id}`] = {
                ...images[name][`_${id}`], after: r(item)
            }
        }
    });

    return images;
}

export default {
    "plasticka-chirurgie": {
        full: importAll(require.context('./plasticka-chirurgie', false, /\.(png|jpe?g|svg)$/)),
        tn: tns["plasticka-chirurgie"]
    },
    "laserova-estetika": {
        full: importAll(require.context('./laserova-estetika', false, /\.(png|jpe?g|svg)$/)),
        tn: tns["laserova-estetika"]
    },
    "obecna-a-zilni-chirurgie": {
        full: importAll(require.context('./obecna-a-zilni-chirurgie', false, /\.(png|jpe?g|svg)$/)),
        tn: tns["obecna-a-zilni-chirurgie"]
    },
    "dermatologie": {
        full: importAll(require.context('./dermatologie', false, /\.(png|jpe?g|svg)$/)),
        tn: tns["dermatologie"]
    },
    "orl-usni-nosni-krcni": {
        full: importAll(require.context('./orl-usni-nosni-krcni', false, /\.(png|jpe?g|svg)$/)),
        tn: tns["orl-usni-nosni-krcni"]
    },
    "ostatni": {
        full: importAll(require.context('./ostatni', false, /\.(png|jpe?g|svg)$/)),
        tn: tns["ostatni"]
    },
}


// WEBPACK FOOTER //
// ./src/assets/img/llc/surgery/procedures/index.js